import React, { useState } from "react";
import { Button, Drawer } from "antd";
import { useNavigate } from "react-router-dom";

const CustomDrawer = () => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const navigate = useNavigate();
  return (
    <>
      <Button type="primary" onClick={showDrawer}>
        Menu
      </Button>
      <Drawer
        title="Shravan Meena"
        placement="right"
        onClose={onClose}
        visible={open}
      >
        <p
          onClick={() => {
            onClose();
            navigate("/");
          }}
        >
          Home
        </p>
        <p
          onClick={() => {
            onClose();
            navigate("/blog");
          }}
        >
          Blog
        </p>
        <p
          onClick={() => {
            onClose();
            navigate("/video");
          }}
        >
          Videos
        </p>
      </Drawer>
    </>
  );
};

export default CustomDrawer;
